import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { appContext } from '../../../providers/appProvider';

export default function Body({ indication, children, ...props }) {
  const { headerHeight } = useContext(appContext);

  return (
    <main {...props} className="site-content" style={{ paddingTop: headerHeight }} >
      {children}
    </main>
  );
}

Body.propTypes = {
  indication: PropTypes.string,
  children: PropTypes.node.isRequired,
};
